var map = {
	"./ansar.png": "d8e2",
	"./ayandeh.png": "2706",
	"./central-bank.png": "b50b",
	"./dey.png": "96e3",
	"./eghtesad-novin.png": "35c8",
	"./gardeshgari.png": "de5b",
	"./ghavamin.png": "2466",
	"./hekmat-iranian.png": "c7c5",
	"./iran-venezuela.png": "32e4",
	"./iran-zamin.png": "6b04",
	"./karafarin.png": "1c54",
	"./keshavarzi.png": "cd77",
	"./markazi.png": "c9d1",
	"./maskan.png": "4f21",
	"./mehr-iran.png": "9fb9",
	"./mellat.png": "f90c",
	"./melli.png": "6890",
	"./parsian.png": "1d57",
	"./pasargad.png": "8719",
	"./post.png": "611a",
	"./refah.png": "daa4",
	"./resalat.png": "5d96",
	"./saderat.png": "f3c8",
	"./saman.png": "d5df",
	"./sanat-o-madan.png": "aec2",
	"./sarmayeh.png": "567e",
	"./sepah.png": "5d6d",
	"./shahr.png": "bd93",
	"./sina.png": "0cf5",
	"./tejarat.png": "7d4b",
	"./toose-taavon.png": "025a",
	"./tosee-saderat.png": "334a",
	"./tosee.png": "bb7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5331";